import { type FC } from "react";

import { VolumeHoverProvider } from "~/feature/chart/providers/VolumeHoverProvider";
import type { IMarket } from "~/types/event";

import { ChartTooltip } from "../ChartTooltip";
import { ChartXAxis } from "../ChartXAxis";
import { Footer } from "../Footer";
import { LinearChart } from "../LinearChart";
import { MarketsLegend } from "../MarketsLegend";
import { NewsLegend } from "../NewsLegend";
import { NewsMarkers } from "../NewsMarkers";
import { TopBar } from "../TopBar";
import { VolumeChart } from "../VolumeChart";
import * as Styled from "./CoreChart.styles";

interface ICoreChartProps {
  markets: IMarket[];
}

export const CoreChart: FC<ICoreChartProps> = ({ markets }) => {
  if (!markets.length) {
    return null;
  }

  return (
    <VolumeHoverProvider>
      <Styled.Root>
        <TopBar />
        <MarketsLegend />
        <NewsLegend />

        <Styled.Plot>
          <Styled.LineArea>
            <LinearChart />
            <NewsMarkers />
            <ChartTooltip />
          </Styled.LineArea>

          <VolumeChart />
        </Styled.Plot>

        <ChartXAxis />
        <Footer />
      </Styled.Root>
    </VolumeHoverProvider>
  );
};
